import { Component, inject } from '@angular/core';
import { NurseryTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  NurseryTypeCreateDto,
  NurseryTypeDto,
  NurseryTypeExcelDownloadDto,
  NurseryTypeUpdateDto,
} from '../proxy/planning/dtos/nursery-type';
import { NURSERYTYPE_CONFIG, NURSERYTYPE_FIELDS } from './nursery-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-nursery-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, NurseryTypeService, ConfirmationService],
  templateUrl: './nursery-type.html',
  styleUrl: './nursery-type.scss',
})
export class NurseryType extends BaseCrudComponent<
  NurseryTypeDto,
  NurseryTypeCreateDto,
  NurseryTypeUpdateDto,
  NurseryTypeExcelDownloadDto
> {
  service = inject(NurseryTypeService);
  config = NURSERYTYPE_CONFIG;
  fields = NURSERYTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: NurseryTypeDto): NurseryTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'NurseryType';
  }
}
